<template>
  <div class="block page5 f-c">
    <PageHeader
      :title="moduleData['3_9_2_1']"
      :sub-title="moduleData['3_9_2_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>
    <div class="page5-body">
      <TableNav width="1774px" style="height: 70px; margin-bottom: 25px">
        <template v-slot:title>
          <div class="page5-table-header f-r j-b">
            <div class="page5-table-title">
              {{ PAGE_TEXT[commonLang].tableTitle }}
            </div>
            <div class="page5-table-sub-title">
              {{ PAGE_TEXT[commonLang].totalResidential }}{{ catData.count || 0 }} {{ PAGE_TEXT[commonLang].unitPiece }}
            </div>
          </div>
        </template>
      </TableNav>
      <div style="width: 1774px" class="f-r j-b">
        <PTable :col-data="colData" :row-data="rowData.slice(0,10)" style="height: 706px">
          <Empty :text="PAGE_TEXT[commonLang].noResidentialCoverage" v-if="!rowData.length"/>
        </PTable>
        <PTable v-if="rowData.length > 10" style="height: 706px" :col-data="colData" :row-data="rowData.slice(10,20)" >
          <Empty :text="PAGE_TEXT[commonLang].noResidentialCoverage" v-if="!rowData.length"/>
        </PTable>
      </div>

      <div class="page5-map-tips">
        <div class="page-tips2" style="padding-bottom: 27px;">
          <div
            v-if="rowData.length < 20"
            class="gray"
          >{{ PAGE_TEXT[commonLang].filterNote }}</div>
          <div v-if="reportCustomization.showWater">
            {{ PAGE_TEXT[commonLang].moreInfo }}
          </div>
        </div>
        <div v-if="reportCustomization.showDataSource">
          {{ PAGE_TEXT[commonLang].dataSource }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";
import Empty from "./components/Empty";

const props = defineProps({
    pageNum: String,
    catData: {
      type: Object,
      default: () => {
        return {
          count: 0,
          poi: []
        };
      },
    },
    moduleData: {
      type: Object,
      default: () => {
        return {
        };
      },
    },
    reportCustomization: {
      type: Object,
      default: () => {},
    },
    commonLang: {
      type: String,
      default: 'zh'
    }
  });

const PAGE_TEXT = {
  'zh': {
    tableTitle: '距离最近调研地住宅小区信息（最多展示TOP 20）',
    totalResidential: '总住宅项目数：',
    unitPiece: '个',
    noResidentialCoverage: '当前区域暂无住宅覆盖',
    filterNote: '* 注：列表中过滤了详情信息不足的小区，会出现总数与列表不一致的情况。',
    moreInfo: '>更多住宅分布于APP「数据地图/市调详情_周边配套」中查看',
    dataSource: '数据来源：边界房产大数据，房产平台数据整合',
    serialNumber: '序号',
    communityName: '小区名称',
    plannedHouseholds: '规划户数',
    households: '户',
    housePrice: '房价',
    yuanPerSqm: '元/㎡',
    propertyFee: '物业费',
    distance: '距离'
  },
  'en': {
    tableTitle: 'Nearest Residential Community Information (Top 20 Maximum)',
    totalResidential: 'Total Residential Projects: ',
    unitPiece: 'pieces',
    noResidentialCoverage: 'No residential coverage in current area',
    filterNote: '* Note: The list filters out communities with insufficient details, which may cause inconsistency between the total number and the list.',
    moreInfo: '',
    dataSource: 'Data Source: Boundary real estate big data, real estate platform data integration',
    serialNumber: 'No.',
    communityName: 'Community Name',
    plannedHouseholds: 'Planned Households',
    households: 'households',
    housePrice: 'House Price',
    yuanPerSqm: 'CNY/㎡',
    propertyFee: 'Property Fee',
    distance: 'Distance'
  }
};

    const colData = computed(() => [
      { prop: "index", width: "67px", label: PAGE_TEXT[props.commonLang].serialNumber },
      { prop: "name", width: "303px", label: PAGE_TEXT[props.commonLang].communityName },
      {
        prop: "households",
        width: "133px",
        label: PAGE_TEXT[props.commonLang].plannedHouseholds,
        subLabel: `(${PAGE_TEXT[props.commonLang].households})`,
      },
      {
        prop: "housingPrice",
        width: "123px",
        label: PAGE_TEXT[props.commonLang].housePrice,
        subLabel: `(${PAGE_TEXT[props.commonLang].yuanPerSqm})`,
      },
      {
        prop: "propertyFee",
        width: "143px",
        label: PAGE_TEXT[props.commonLang].propertyFee,
        subLabel: `(${PAGE_TEXT[props.commonLang].yuanPerSqm})`,
      },
      { prop: "distanceKilo", width: "87px", label: PAGE_TEXT[props.commonLang].distance , subLabel: "km"},
    ]);
    const rowData = computed(() => {
      if (!props.catData.poi) return []
      return props.catData.poi.filter((f) => !(f.households === '0' && !f.housingPrice && !f.propertyFee)).map((el,index) => {
          let _index = index + 1
          return {
              index: _index < 10 ? ('0' + _index) : _index,
              ...el
          }
      })
    });
</script>

<style lang="less">
.page5 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;

  .page5-body {
    flex: 1;
    padding: 17px 20px 0 39px;

    .page5-table-header {
      display: flex;
      .page5-table-title {
        font-size: 36px;
      }
      .page5-table-sub-title {
        font-size: 21px;
      }
    }

    .page5-map-tips {
      padding-top: 64px;
      padding-right: 24px;
      width: 100%;
      flex-shrink: 0;
      text-align: right;
      height: 28px;
      font-size: 20px;
      font-weight: 400;
      color: #9a9a9a;
      line-height: 28px;
    }
  }
}
</style>
